import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, EmptyState } from "../AdminUI";
import { ScrollText } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Activity Log</h1>
      <Card>
        {logs.length === 0 ? <EmptyState icon={ScrollText} title="No activity yet" /> : (
          <div className="divide-y divide-gray-100 text-sm">
            {logs.map((l) => (
              <div key={l.id} className="flex items-center justify-between py-2.5">
                <div><span className="font-semibold text-[var(--navy)]">{l.action}</span> <span className="text-gray-400">{l.detail}</span></div>
                <div className="text-right"><span className="text-xs text-gray-500">{l.actor}</span><br /><span className="text-[11px] text-gray-400">{new Date(l.at).toLocaleString()}</span></div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
